module.exports = __webpack_public_path__ + "static/media/billiards-live.2080c3ab.png";